import { render, staticRenderFns } from "./VenuePaymentMethodsDialog.vue?vue&type=template&id=5226a759"
import script from "./VenuePaymentMethodsDialog.vue?vue&type=script&lang=ts"
export * from "./VenuePaymentMethodsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports